<mat-form-field
  style="width: 100%"
  [formGroup]="parentForm()"
  floatLabel="always"
>
  <mat-label>{{ field().label }}</mat-label>
  <input
    matInput
    [placeholder]="field().placeholder"
    [type]="field().type === 'password' ? (hidePassword ? 'password' : 'text') : field().type"
    [formControlName]="field().key"
    [autocomplete]="field().autocomplete"
    [required]="field().required"
    [attr.aria-required]="field().required"
  />
  @if (iconName() && field().type !== "password") {
    <mat-icon matSuffix>{{ iconName() }}</mat-icon>
  }
  @if (iconName() && field().type === "password") {
    <button
      mat-icon-button
      matSuffix
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
      type="button"
    >
      <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
  }
  @if (hasErrors) {
    <mat-error>{{ errorsList[0] }}</mat-error>
  }
</mat-form-field>
